/**
 * Simple Product Image Switcher - No Zoom Glitches
 */
(function() {
  'use strict';

  function initProductImages() {
    const mainImage = document.querySelector('#product-featured-image');
    const thumbnails = document.querySelectorAll('.thumb-link');
    
    if (!mainImage || !thumbnails.length) return;

    // Setup thumbnail clicks
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        
        const newImageSrc = this.dataset.image;
        if (newImageSrc && mainImage.src !== newImageSrc) {
          mainImage.src = newImageSrc;
          updateActiveThumbnail(index);
        }
      });
    });

    // Simple hover effect on main image - no layout shift
    const imageContainer = mainImage.closest('.product-image-gallery');
    if (imageContainer) {
      imageContainer.style.overflow = 'hidden';
      
      imageContainer.addEventListener('mouseenter', function() {
        mainImage.style.transform = 'scale(1.1)';
      });
      
      imageContainer.addEventListener('mouseleave', function() {
        mainImage.style.transform = 'scale(1)';
      });
    }
  }

  function updateActiveThumbnail(activeIndex) {
    document.querySelectorAll('.thumb-link img').forEach((img, i) => {
      img.classList.toggle('current', i === activeIndex);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductImages);
  } else {
    initProductImages();
  }

})();